/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * The verification result.
 */
export interface PresentationVerify {
    /** Indicates whether the presentation is verified. */
    verified: boolean;
}
